/* eslint-disable react/prop-types */
import React from 'react';

const FeaturedImage = ({ image, link }) => {
  let thumbnail = image?.media_details?.sizes?.full;
  if (image?.media_details?.sizes?.['1536x1536']) {
    thumbnail = image?.media_details?.sizes?.['1536x1536'];
  }
  return (
    <div className="featured-image">
      <a href={link}>
        <img
          alt={image?.alt_text}
          height={thumbnail?.height}
          src={thumbnail?.source_url}
          width={thumbnail?.width}
        />
      </a>
    </div>
  );
};

export default FeaturedImage;
